import React from 'react';
import { DriverMe } from '../../services/driverApi';
import { DriverCopy, DriverLang, formatMoney, MONTHLY_SUBSCRIPTION, workStatusLabel } from './driverI18n';
import { DriverHeader } from './DriverHeader';

interface Props {
  t: DriverCopy;
  lang: DriverLang;
  profile: DriverMe;
  onBack: () => void;
  onLang: (lang: DriverLang) => void;
  onBalance: () => void;
  onHelp: () => void;
  onLogout: () => void;
}

export const DriverMenuPage: React.FC<Props> = ({
  t,
  lang,
  profile,
  onBack,
  onLang,
  onBalance,
  onHelp,
  onLogout,
}) => {
  const fio = profile.fio || '—';
  const status = workStatusLabel(t, profile.workStatus, profile.isSelfemployed);
  const amount = Number(profile.billing?.amount || 0) || MONTHLY_SUBSCRIPTION;

  return (
    <div className="app-container driver-cabinet">
      <DriverHeader t={t} title={t.menu} onBack={onBack} />
      <main className="main-content driver-main driver-menu-page">
        <section className="driver-menu-card">
          <div className="driver-menu-label">{t.profile}</div>
          <div className="driver-menu-row static">
            <span>{t.fio}</span>
            <strong>{fio}</strong>
          </div>
          <div className="driver-menu-row static">
            <span>{t.status}</span>
            <strong>{status}</strong>
          </div>
        </section>

        <section className="driver-menu-card">
          <div className="driver-menu-label">{t.language}</div>
          <div className="driver-lang-switch">
            <button type="button" className={lang === 'ru' ? 'active' : undefined} onClick={() => onLang('ru')}>
              {t.russian}
            </button>
            <button type="button" className={lang === 'kk' ? 'active' : undefined} onClick={() => onLang('kk')}>
              {t.kazakh}
            </button>
          </div>
        </section>

        <button type="button" className="driver-menu-link" onClick={onBalance}>
          <span>{t.balance}</span>
          <strong>
            {formatMoney(amount)} ₸ <span className="chevron">›</span>
          </strong>
        </button>

        <button type="button" className="driver-menu-link" onClick={onHelp}>
          {t.help}
          <span className="chevron">›</span>
        </button>

        <button type="button" className="btn-logout driver-logout" onClick={onLogout}>
          {t.logout}
        </button>
      </main>
    </div>
  );
};
